let Values = {
  DRESSAGE    : 'DRESSAGE',
  ENDURANCE   : 'ENDURANCE',
  CARRIAGE    : 'CARRIAGE',
  SHOW_JUMPING: 'SHOW_JUMPING',
  EVENTING    : 'EVENTING',
  VAULTING    : 'VAULTING',
  HORSEBALL   : 'HORSEBALL',
  POLO        : 'POLO',
  HUNTER      : 'HUNTER',
  CUSTOM      : 'CUSTOM'
};

export default Object.seal({
  ...Values,

  /* All values */
  values: Object.keys(Values),

  /* Get name for value. */
  name: (value, custom) => {
    switch (value) {

      case Values.CUSTOM:
        return custom;

      default:
        return value;
    }
  }
});
